export default [
  '雙北',
  '北部',
  '中部',
  '南部',
  '東部',
]
